/* ==========================================================================
   TYMZO SEARCH ENHANCEMENTS V1
   ========================================================================== */

(() => {
  'use strict';

  const ROOT_SELECTOR = 'predictive-search-component';

  const ITEM_SELECTOR =
    '.predictive-search-results__card, [ref="resultsItems[]"]';

  const escapeRegExp = (value = '') =>
    value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

  const getSearchTerm = (root) => {
    const input =
      root.querySelector(
        'input[type="search"], input[role="combobox"], input'
      );

    return input?.value?.trim() || '';
  };

  function highlight(node, term) {
    if (!node.nodeValue || !term) return;

    const regex = new RegExp(
      '(' + escapeRegExp(term) + ')',
      'ig'
    );

    if (!regex.test(node.nodeValue)) return;

    const fragment = document.createDocumentFragment();

    let last = 0;

    node.nodeValue.replace(regex, (match, p1, offset) => {

      if (offset > last) {
        fragment.append(
          node.nodeValue.slice(last, offset)
        );
      }

      const mark = document.createElement('mark');

      mark.className = 'tymzo-search-highlight';

      mark.textContent = match;

      fragment.append(mark);

      last = offset + match.length;
    });

    if (last < node.nodeValue.length) {
      fragment.append(
        node.nodeValue.slice(last)
      );
    }

    node.replaceWith(fragment);
  }

  function highlightTitles(item, term) {

    const titles = item.querySelectorAll(
      'h3,h4,[class*="title"]'
    );

    titles.forEach((title) => {

      const walker = document.createTreeWalker(
        title,
        NodeFilter.SHOW_TEXT
      );

      const nodes = [];

      let current;

      while ((current = walker.nextNode())) {
        nodes.push(current);
      }

      nodes.forEach((node) => {
        highlight(node, term);
      });

    });

  }

  function addBadge(item) {

    if (item.querySelector('.tymzo-search-badge')) {
      return;
    }

    const text =
      item.textContent.toLowerCase();

    let label = '';
    let modifier = '';

    if (text.includes('nouveau')) {

      label = 'Nouveau';

      modifier = 'tymzo-search-badge--new';

    } else if (
      text.includes('promotion')
    ) {

      label = 'Promotion';

      modifier = 'tymzo-search-badge--sale';

    } else if (
      text.includes('best seller')
    ) {

      label = 'Best Seller';
    }

    if (!label) return;

    const title =
      item.querySelector(
        'h3,h4,[class*="title"]'
      );

    if (!title) return;

    const badge =
      document.createElement('span');

    badge.className =
      'tymzo-search-badge ' + modifier;

    badge.textContent = label;

    title.insertAdjacentElement(
      'afterend',
      badge
    );

  }

  function animateItems(root) {

    const items =
      [...root.querySelectorAll(ITEM_SELECTOR)];

    items.forEach((item, index) => {

      item.classList.remove(
        'tymzo-search-enter'
      );

      item.style.setProperty(
        '--tymzo-search-delay',
        Math.min(index * 35, 210) + 'ms'
      );

      void item.offsetWidth;

      item.classList.add(
        'tymzo-search-enter'
      );

    });

  }
    function addViewAll(root) {

    const container =
      root.querySelector(
        '.predictive-search-results__inner,[ref="predictiveSearchResults"]'
      );

    if (!container) return;

    const term = getSearchTerm(root);

    if (!term) return;

    let button =
      container.querySelector(
        '.tymzo-search-view-all'
      );

    const url =
      new URL(
        window.Theme?.routes?.search_url || '/search',
        window.location.origin
      );

    url.searchParams.set('q', term);

    if (!button) {

      button =
        document.createElement('a');

      button.className =
        'tymzo-search-view-all';

      container.append(button);

    }

    button.href = url.toString();

    button.textContent =
      'Voir tous les résultats pour "' +
      term +
      '"';

  }

 function enhance(root) {
  const items = [...root.querySelectorAll(ITEM_SELECTOR)];

  items.forEach((item) => {
    addBadge(item);
  });

  animateItems(root);
}

  function observe(root) {

    if (
      root.dataset.tymzoReady === 'true'
    ) {
      return;
    }

    root.dataset.tymzoReady = 'true';

    let timer;

    const refresh = () => {

      clearTimeout(timer);

      timer = setTimeout(() => {

        enhance(root);

      }, 40);

    };

    const observer =
      new MutationObserver(refresh);

    observer.observe(root, {

      subtree: true,

      childList: true

    });

    root.addEventListener(
      'input',
      refresh
    );

    root.addEventListener(
      'focusin',
      refresh
    );

    refresh();

  }

  function init(scope = document) {

    scope
      .querySelectorAll(ROOT_SELECTOR)
      .forEach(observe);

  }

  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',

      () => init(),

      { once: true }

    );

  } else {

    init();

  }

  document.addEventListener(

    'shopify:section:load',

    (event) => {

      init(event.target);

    }

  );

})();
